import { newDateWithTime } from "helpers/dateTools"
import { conceptOpt, ivaOptions, decimalsOptions } from "helpers/dictionary"

export const initialValues = {
  addNotes: {
    date: newDateWithTime(),
    blockDate: false,
    invoiceKey: "",
    folio: "",
    quantity: "",
    price: "",
    subTotal: 0,
    total: 0,
    iva: ivaOptions[0],
    grouped: conceptOpt[0],
    idReason: null,
    decimals: decimalsOptions[0],
    block: true,
    discount: 0,
    discountType: "",
    discountAmount: 0,
    subTotalWithDiscount: 0,
    totalWithDiscount: 0,
    retention: 0,
    totalRetention: 0,
  },
  transmitter: {
    idCompany: null,
    rfc: "",
    permissionsOpt: [],
    permission: null,
    series: null,
    logo: null,
    invoiceConcept: "",
    confirmed: false
  },
  receiver: {
    idAccount: null,
    customersOpt: [],
    searchCustomer: "",
    companyName: "",
    rfc: "",
    email: "",
    emails: [],
    regime: null,
    regimeOpt: [],
    paymentMethod: null,
    paymentType: null,
    satUsage: null,
    cp: "",
    confirmed: false,
    editData: false,
  },
  comments: {
    comment: ""
  }
}

export const requiredValues = {
  addNotesRequired: {
    date: { required: true },
    folio: { required: true },
    quantity: { required: true },
    price: { required: true },
    decimals: { required: true },
    subTotal: { required: true },
    iva: { required: true },
    idReason: { required: true },
    grouped: { required: true },
  },
  transmitterRequired: {
    idCompany: { required: true },
    rfc: { required: true },
    permission: { required: true },
    series: { required: true },
    logo: { required: true }
  },
  receiverRequired: {
    emails: { required: true, isEmail: true },
    regime: { required: true },
    rfc: { required: true },
    companyName: { required: true },
    paymentMethod: { required: true },
    paymentType: { required: true },
    satUsage: { required: true },
    cp: { required: true }
  }
}